import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import { getAllSearchHistory } from "../../Services/services";
import {
  CHEVRON_LEFT,
  EMPTY_SEARCH_2,
  SEARCH_INPUT_ICON,
  SEARCH_INPUT_WHITE,
} from "../../assets";
import TableComponent from "../../shared/components/table";
import { SEARCH_HISTORY_COLUMN } from "../../shared/components/table/columns";
import { SearchHistoryTypes } from "../../types";

function SearchHistory() {
  const { data: searchHistory } = useQuery("search", getAllSearchHistory);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentpage, setCurrentpage] = useState(0);
  const [propertyModal, setPropertyModal] = useState(false);
  const filterProperty = searchHistory?.data?.filter(
    (item: SearchHistoryTypes) =>
      item.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.address?.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const pagesRefs = useRef<(HTMLButtonElement | null)[]>([]);

  useEffect(() => {
    const selectedButton = pagesRefs.current[currentpage];
    if (selectedButton) {
      selectedButton.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [currentpage]);

  return (
    <div className="p-3 sm:p-5">
      <div className="flex items-start flex-col">
        <span className="text-[#2A2E34] font-semibold text-xl sm:text-2xl">
          Search History
        </span>
        <span className="text-primary-50 font-medium text-sm">
          List of all searches you have made
        </span>
      </div>

      <div className="w-full mt-5 border border-borderColor py-4 rounded-xl">
        <div className="w-full flex flex-col sm:flex-row justify-between items-start sm:items-center px-4 gap-3">
          <span className="text-[#2A2E34] font-semibold text-[16px]">
            Search History
          </span>
          <div className="w-full sm:w-fit items-center gap-x-2 flex px-3 py-2 rounded-xl border border-borderColor">
            <img
              src={SEARCH_INPUT_ICON}
              className="w-[20px] h-[20px] flex-shrink-0"
              alt=""
            />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full bg-transparent placeholder:text-sm outline-none min-w-0"
              placeholder="Search property title,location"
            />
          </div>
        </div>

        {searchHistory?.data?.length > 0 ? (
          <div className="mt-2">
            <div className="overflow-x-auto">
              <TableComponent
                DATA={filterProperty}
                //@ts-ignore
                COLUMNS={SEARCH_HISTORY_COLUMN}
              />
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-end pt-3 space-y-3 sm:space-y-0 sm:space-x-5 pr-5">
              <button
                type="button"
                onClick={() =>
                  setCurrentpage(searchHistory.meta.current_page - 1)
                }
                disabled={searchHistory.meta.current_page === 1}
                className={`border border-[#EBEBEB] rounded-xl w-[40px] h-[40px] flex items-center gap-x-2 justify-center ${
                  searchHistory.meta.current_page === 1 &&
                  "opacity-50 cursor-not-allowed"
                }`}
              >
                <img src={CHEVRON_LEFT} className="w-[20px] h-[20px]" alt="" />
              </button>

              <div
                className={`flex items-center gap-x-2 ${
                  searchHistory.meta.links.slice(1, -1).length > 5 &&
                  "max-w-[200px] sm:max-w-[300px] overflow-x-auto"
                }`}
              >
                {searchHistory.meta.links
                  .slice(1, -1)
                  .map((page: any, index: number) => (
                    <button
                      key={index}
                      ref={(el) => (pagesRefs.current[index] = el)}
                      onClick={() => {
                        page.url && setCurrentpage(Number(page.label));
                      }}
                      className={`flex items-center justify-center pt-[0.5px] hover:bg-globalGold hover:text-white transition-all duration-300 gap-x-3 min-w-[40px] h-[40px] rounded-xl ${
                        page.active
                          ? "bg-globalGold text-white"
                          : "border text-[#2A2E34]"
                      }`}
                    >
                      <span className={`text-[13px]`}>{page.label}</span>
                    </button>
                  ))}
              </div>

              <button
                type="button"
                onClick={() =>
                  setCurrentpage(searchHistory.meta.current_page + 1)
                }
                disabled={
                  searchHistory.meta.current_page ===
                  searchHistory.meta.last_page
                }
                className={`border border-[#EBEBEB] rounded-xl gap-x-2 w-[40px] h-[40px] flex items-center justify-center ${
                  searchHistory.meta.current_page ===
                    searchHistory.meta.last_page &&
                  "opacity-50 cursor-not-allowed"
                }`}
              >
                <img
                  src={CHEVRON_LEFT}
                  className="w-[20px] h-[20px] scale-x-[-1]"
                  alt=""
                />
              </button>
            </div>
          </div>
        ) : (
          <div className="flex flex-col gap-y-2 pb-5 justify-center items-center w-full px-4">
            <img
              src={EMPTY_SEARCH_2}
              className="w-[120px] h-[100px] sm:w-[147.69px] sm:h-[120px]"
              alt=""
            />
            <span className="text-lg sm:text-xl font-bold text-customDark text-center">
              No Searches Yet
            </span>
            <span className="text-sm font-medium text-primary-50 max-w-md text-center">
              No search history to be displayed, click the button below to begin
              your search.
            </span>
            <button
              onClick={() => setPropertyModal(true)}
              className="w-fit hover:scale-95 transition-all duration-300 bg-globalGreen px-5 py-2 rounded-3xl flex items-center justify-center gap-x-2"
            >
              <img
                src={SEARCH_INPUT_WHITE}
                className="w-[20px] h-[20px]"
                alt=""
              />
              <span className="text-[16px] font-medium text-white">
                Search Property
              </span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default SearchHistory;
